export default [
  /* {
		header: "Account",
		action: "general",
		resource: "general",
	}, */
  /* {
		title: "My Subscription",
		route: "account-settings-plans",
		icon: "CreditCardIcon",
		action: "general",
		resource: "general",
	}, */
  {
    title: 'Account Settings',
    route: 'account-settings',
    icon: 'SettingsIcon',
    action: 'general',
    resource: 'general',
  },
  {
    title: 'My Subscription',
    route: 'financial-settings',
    icon: 'BarChart2Icon',
    action: 'general',
    resource: 'general',
  },
  /* "Satın Aldıklarım" is hidden (PM 04.08.2026 item 11). The page could
    never show anything: no production code writes Payment documents, and
    the iyzico webhook records status transitions only, never amounts. The
    /my-payments route and MyPayments.vue are deliberately left in place so
    existing links keep working and the entry can be restored the day real
    billing data exists. See exec_plan/PM_NEW_ANALYSIS_2026-08-04/05_*.md.
  {
    title:"Satın Aldıklarım",
    route:"my-payments",
    icon:"ShoppingCartIcon",
    action: 'general',
    resource: 'general',
  }, */
  /* {
		title: "Reports",
		route: "reports",
		icon: "FileTextIcon",
		action: "general",
		resource: "general",
	}, */
  /* {
		title: "Perm Check",
		route: "acl",
		icon: "LockIcon",
		action: "general",
		resource: "general",
  }, */
  {
    title: 'Forms',
    route: 'forms',
    icon: 'FileIcon',
    action: 'general',
    resource: 'general',
  },
]
